import { Card } from './BmsCardPrimitives'
import ValueGrid from './ValueGrid'

const NtcTemperaturesCard = ({ ntcTemperatures }) => (
  <Card>
    <span className="text-sm font-medium text-[#252a34] flex items-center gap-1.5 mb-1">
      <span className="material-icons text-base text-[#616a79]">show_chart</span>
      NTC Temperatures
      <span className="bg-[#e6f8e6] text-[#03791f] text-xs font-medium rounded-full px-2 py-0.5 ml-1">{ntcTemperatures.length}</span>
    </span>
    <ValueGrid
      items={ntcTemperatures}
      columns={2}
      legend={[{ label: 'Min Temperature', color: '#2a78d6' }, { label: 'Max Temperature', color: '#d03b3b' }]}
      flagStyles={{
        min: { bg: 'bg-[#e4effc]', text: 'text-[#2a78d6]' },
        max: { bg: 'bg-[#fde9e7]', text: 'text-[#d03b3b]' },
      }}
    />
  </Card>
)

export default NtcTemperaturesCard
